const authentication = require('../../../react-azure-adb2c2').default;



export const updatecomment = (values: any) => {
    console.log(values)
    // alert(values.id)
    const url = process.env.REACT_APP_API_CRM_URL + `/v1/rent/introduction/details/updatecomment/` + values.id
    // const url = `http://localhost:5000/v1/rent/introduction/details/updatecomment/` + values.id
    // alert(JSON.stringify(values))
    const token = authentication.getAccessToken();
    console.log(values)
    // alert(url)
    //const search = values ? values : {};
    //  alert(url)
    // alert(JSON.stringify(values))
    return fetch(url, {
        method: 'put',
        body: JSON.stringify(values),

        headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' },

    })
        .then(res => res.json())
        .then(payload => ({ payload }))
        .catch(error => ({ error }));

}